import _, { truncate } from "lodash";
import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import { CommandItem } from "cmdk";

import { Badge } from "@/components/ui/Badge";
import { Warning20 } from "@/components/ui/SvgIcon";
import { Tooltip } from "@/components/ui/Tooltip";

import { DEVICE_BATTERY_BADGE_VARIANTS } from "@/features/system/constants";
import { BatteryState, Device } from "@/features/system/types";

import { ROUTES } from "@/constants/routes";
type Props = {
  device: Device;
  onSelect?: (to: string) => void;
  query?: string;
};
export const SearchItemDevice = ({
  device,
  onSelect = () => {},
  query = "",
}: Props) => {
  const to = `${ROUTES.SYSTEM}/${device.deviceId}`;

  const batterySocPercent = _.get(device, "batterySocPercent", null);

  const batteryState = _.get(
    device,
    "batteryState",
    "BATTERY_STATE_UNSPECIFIED",
  );

  return (
    <CommandItem
      data-testid="search-item"
      onSelect={() => onSelect(to)}
      className="group relative cursor-pointer select-none items-center bg-white px-3 py-[2px] text-sm outline-none first:before:block first:before:h-[12px] first:before:w-full first:before:content-[''] last:after:block last:after:h-[12px] last:after:w-full last:after:content-['']   data-[disabled='true']:pointer-events-none data-[disabled='true']:opacity-50 [&:not(:last-child)]:mb-2 "
    >
      <Link
        to={to}
        className="flex h-full rounded-md py-[7px] pl-3 pr-2 group-aria-selected:bg-[#F8FAFC]"
      >
        <div className="flex-1 overflow-hidden">
          <div className="flex h-full items-center justify-between font-sora text-sm font-medium tracking-[-0.003em] text-chorus-black-200">
            <Highlighter
              highlightClassName="bg-chorus-teal-100 rounded-[2px] text-chorus-black-100"
              searchWords={query?.split(" ")}
              autoEscape={true}
              textToHighlight={truncate(device.deviceId, { length: 40 })}
            />
            <div className="flex gap-[6px]">
              <Badge
                className=" font-manrope text-xxs font-semibold leading-4"
                variant={DEVICE_BATTERY_BADGE_VARIANTS[batteryState]}
              >
                {batterySocPercent !== null
                  ? `${batterySocPercent}%`
                  : BatteryState[batteryState]}
              </Badge>
              {device.hasUnresolvedAlert && (
                <Tooltip
                  content="Show Alerts"
                  placement={"top-end"}
                  className="w-fit"
                >
                  <div
                    data-testid="search-item-device-unresolved-alert"
                    className=" flex h-[20px] w-[24px]  items-center justify-center rounded-[20px] bg-chorus-red-100 pb-[1.7px] "
                  >
                    <Warning20 className="w-[17px]  fill-chorus-red-600" />
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
        </div>
      </Link>
    </CommandItem>
  );
};
